<template>
  <div id='kyc-result'>
      <img src="@/assets/kyc.png" alt="">
      <p>您的身份认证资料已提交， <br/>请在“我的-身份认证”中查看结果。</p>
      <div id="done-btn"  type="primary" @click="done">完成</div>
  </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    mounted() {
        var btn = document.getElementById("done-btn"); 
        btn.addEventListener("click", function () { 
            //  安卓
            // debugger
            if (window.closeH5) {
                closeH5.setValue('close');
            }
        });
    },
    methods: {
        done() {
            this.setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('closeH5', '');
            }); 
        },
        setupWebViewJavascriptBridge(callback) {
            if (window.WebViewJavascriptBridge) {
                return callback(WebViewJavascriptBridge);
            }
            if (window.WVJBCallbacks) {
                return window.WVJBCallbacks.push(callback);
            }
            window.WVJBCallbacks = [callback];
            var WVJBIframe = document.createElement('iframe');
            WVJBIframe.style.display = 'none';
            WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
            document.documentElement.appendChild(WVJBIframe);
            setTimeout(function () {
                document.documentElement.removeChild(WVJBIframe)
            }, 0)
        }
    }
}
</script>

<style lang='less'>
#kyc-result {
    height: 100vh;
    background: #ffffff;
    padding-top: 200px;
    img {
        margin-bottom: 60px;
        width: 343px;
        height: 240px;
    }
    p {
        font-size: 32px;
        line-height: 46px;
        color: #191929;
        margin-bottom: 160px;
    }
    #done-btn {
        margin: 0 auto;
        color: #ffffff;
        line-height: 88px;
        background: #FA9A0A;
        width: 690px;
        height: 88px;
        border-radius: 8px;
        font-size: 32px;
        border-color: #FA9A0A;
    }
}
</style>